import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation DeleteRedirect($data: UpdateRedirectInput!) {
    updateRedirect(data: $data) {
      id
      urlFrom
      urlTo
      redirectCode
    }
  }
`);

export interface UpdateGql {
  updateRedirect: {
    id: number;
  };
}
